import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories, comics } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const categoryComics = comics.filter((c) => c.category === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="w-full px-4 md:px-6 py-20 text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name}漫画 - 蜜桃少年漫画`,
          description: category.description,
          url: `https://sdidsa.cn/category/${category.slug}`,
          isPartOf: { '@type': 'WebSite', name: '蜜桃少年漫画', url: 'https://sdidsa.cn' },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://sdidsa.cn' },
            { '@type': 'ListItem', position: 2, name: `${category.name}漫画`, item: `https://sdidsa.cn/category/${category.slug}` },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="bg-background-100">
            <div className="w-full px-4 md:px-6 py-8">
              <Breadcrumb
                items={[
                  { label: '首页', to: '/' },
                  { label: `${category.name}漫画` },
                ]}
              />

              <div className="flex items-center gap-4 mb-2">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-500">
                  <i className={`${category.icon} text-2xl text-background-50`}></i>
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                    {category.name}漫画
                  </h1>
                  <p className="text-sm text-foreground-500 mt-1">
                    {category.description} · 共 {category.count} 部作品
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full px-4 md:px-6 py-2">
            <div className="flex flex-wrap gap-2 py-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="w-full px-4 md:px-6 pb-16">
            {categoryComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
                {categoryComics.map((comic) => (
                  <ComicCard key={comic.id} {...comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无漫画作品</p>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}